"use strict";
/**
 * Collection API Types
 *
 * API request/response types for Pattern Collections.
 * Response types are derived from CollectionRecord via SanitizedRecord<T>,
 * which strips all InternalFields (DynamoDB keys, scanning/moderation/security metadata).
 *
 * This is the reference derivation pattern for all other domains.
 */
Object.defineProperty(exports, "__esModule", { value: true });
